<template>
<div>
    <Breadcrumbs main="Procurement"  title="Purchase Orders" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" style="display: flex; align-items: center;">
                            <router-link to="/procurement/purchase-order/create/new">
                                <div style="display: flex; gap: 12px; align-items: center; color: white;">
                                    <i class="fa fa-light fa-plus"></i>
                                    <h7>Add New Purchase Order</h7>
                                </div>
                            </router-link>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <div class="d-flex flex-wrap" style="gap: 10px;">
                                    <b-input-group class="datatable-btn" style="width: 340px;">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>

                                    <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #563EE0; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="toggleFilterShow()">
                                        <feather type="filter"></feather>
                                        <h7>Filter</h7>
                                    </div>

                                    <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #DC3545; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilter()" v-if="start_date || end_date || status || vendor || project || selectedDepartment || selectedDesignation || selectedEmployee">
                                        <feather type="x"></feather>
                                        <h7>Clear All</h7>
                                    </div>
                                </div>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div class="row mt-2" v-if="filterShow">
                            <div class="col-md-12">
                                <div class="grid-container mt-sm-0">
                                    <div class="grid-item">
                                        <datepicker placeholder="Start Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="start_date"></datepicker>
                                    </div>
                                    <div class="grid-item">
                                        <datepicker placeholder="End Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="end_date"></datepicker>
                                    </div>
                                    <div class="grid-item">
                                        <b-form-select v-model="status" :options="formattedStatus"></b-form-select>
                                    </div>
                                    <div class="grid-item">
                                        <b-form-select v-model="project" :options="formattedProjects"></b-form-select>
                                    </div>
                                    <div class="grid-item">
                                        <b-form-select v-model="vendor" :options="formattedVendors"></b-form-select>
                                    </div>
                                    <div class="grid-item">
                                        <b-form-select v-model="selectedDepartment" :options="formattedDepartment"></b-form-select>
                                    </div>
                                    <div class="grid-item" v-if="selectedDepartment">
                                        <b-form-select v-model="selectedDesignation" :options="formattedDesignation"></b-form-select>
                                    </div>
                                    <div class="grid-item" v-if="selectedDesignation">
                                        <b-form-select v-model="selectedEmployee" :options="formattedEmployee"></b-form-select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue" style="margin-top: 22px;">
                                <b-table show-empty stacked="md" :items="items" :fields="tablefields" :per-page="perPage">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(purchase_order_id)="data">
                                        <span>
                                            <router-link :to="`/procurement/purchase-order/${data.item.id}`" class="link-style">
                                                {{ data.item.purchase_order_id }}
                                            </router-link>
                                        </span>
                                    </template>

                                    <template #cell(subtotal)="data">
                                        <span>
                                            {{ data.item.subtotal }} {{ data.item.currency }}
                                        </span>
                                    </template>

                                    <template #cell(project)="data">
                                        <div style="max-width: 320px;">
                                            <router-link :to="`/project/details/${data.item.project?.id}`" class="link-style">
                                                {{data.item.project?.title }}
                                            </router-link>
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-modal.modal-center @click="deletePO(data.item.id)" v-b-tooltip.hover title="Delete"></feather>
                                            <router-link :to="`/procurement/purchase-order/edit/${data.item.id}`">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit"></feather>
                                            </router-link>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <div class="loader-box">
                                <div class="loader-10"></div>
                            </div>
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this purchase order?</div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

export default {
    components: {
        Datepicker
    },

    data() {
        return {
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'purchase_order_id',
                    label: 'Purchase Order ID',
                    sortable: true
                },
                {
                    key: 'email',
                    label: 'Email',
                    sortable: true
                },
                {
                    key: 'project',
                    label: 'Project',
                    sortable: true
                },
                {
                    key: 'purchase_order_date',
                    label: 'Purchase Order Date',
                    sortable: true
                },
                {
                    key: 'due_date',
                    label: 'Due Date',
                    sortable: true
                },
                {
                    key: 'subtotal',
                    label: 'Grand Total',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],

            filterShow: false,
            filter: null,
            start_date: null,
            end_date: null,
            status: '',
            vendor: '',
            project: '',
            selectedDepartment: '',
            selectedDesignation: '',
            selectedEmployee: '',
            delete_value: null,

            statusOptions: [{
                    text: 'Approved',
                    value: 'APPROVED'
                },
                {
                    text: 'Dismissed',
                    value: 'DISMISSED'
                }
            ],

            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100],
            initialLoad: true,
            isModifyingDate: false,
        };
    },

    computed: {
        ...mapState({
            items: state => state.purchase_order.purchase_order,
            count: state => state.purchase_order.purchase_order_count,
            loading: state => state.purchase_order.submitLoading,
            error: state => state.purchase_order.submitError,
            vendors: state => state.vendor.vendor_without_pg,
            department_list: state => state.department.departments,
            designation_list: state => state.department.designation_by_department,
            employee_list: state => state.department.employee_by_designation,
            projects: state => state.project.project
        }),

        formattedProjects() {
            return [{
                    value: '',
                    text: 'Select a project',
                    disabled: true
                },
                ...this.projects.map(status => ({
                    value: status.id,
                    text: status.title
                }))
            ];
        },

        formattedStatus() {
            return [{
                    value: '',
                    text: 'Select a status',
                    disabled: true
                },
                ...this.statusOptions.map(status => ({
                    value: status.value,
                    text: status.text
                }))
            ];
        },

        formattedVendors() {
            return [{
                    value: '',
                    text: 'Select a vendor',
                    disabled: true
                },
                ...this.vendors.map(vendor => ({
                    value: vendor.user.id,
                    text: vendor.user.user_name
                }))
            ];
        },

        formattedEmployee() {
            return [{
                    value: '',
                    text: 'Select a Employee',
                    disabled: true
                },
                ...this.employee_list.map(emp => ({
                    value: emp.id,
                    text: emp.full_name
                }))
            ];
        },

        formattedDesignation() {
            return [{
                    value: '',
                    text: 'Select Designation',
                    disabled: true
                },
                ...this.designation_list.map(desg => ({
                    value: desg.id,
                    text: desg.title
                }))
            ];
        },

        formattedDepartment() {
            return [{
                    value: '',
                    text: 'Select Department',
                    disabled: true
                },
                ...this.department_list.map(dept => ({
                    value: dept.id,
                    text: dept.name
                }))
            ];
        }
    },

    watch: {
        selectedDepartment(newVal, oldVal) {
            this.$store.dispatch("department/fetchDesignationByDepartment", newVal)
        },

        selectedDesignation(newVal, oldVal) {
            this.$store.dispatch("department/fetchEmployeeByDesignation", newVal)
        },

        currentPage(newCurrentPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/procurement/purchase-order/list',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage
                    }
                });
                this.currentPage = newCurrentPage
                this.$store.dispatch("purchase_order/fetchPO", {
                    perPage: this.perPage,
                    currentPage: newCurrentPage,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.status,
                    vendor: this.vendor,
                    project: this.project,
                    employee: this.selectedEmployee
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }

        },

        perPage(newperPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/procurement/purchase-order/list',
                    query: {
                        page: this.currentPage,
                        perPage: newperPage
                    }
                });
                this.perPage = newperPage
                this.$store.dispatch("purchase_order/fetchPO", {
                    perPage: newperPage,
                    currentPage: this.currentPage,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.status,
                    vendor: this.vendor,
                    project: this.project,
                    employee: this.selectedEmployee
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }

        },

        start_date(newVal, oldVal) {
            if (!this.initialLoad) {
                if (!this.isModifyingDate) {
                    this.isModifyingDate = true;
                    if (this.start_date !== null) {
                    this.start_date = moment(String(this.start_date)).format("YYYY-MM-DD");

                    this.$store.dispatch("purchase_order/fetchPO", {
                        perPage: this.perPage,
                        currentPage: 1,
                        start_date: this.start_date,
                        end_date: this.end_date,
                        search_term: this.filter,
                        status: this.status,
                        vendor: this.vendor,
                        project: this.project,
                        employee: this.selectedEmployee
                    }).then(() => {
                        this.totalRows = this.count;
                        this.initialLoad = false;
                        this.isModifyingDate = false;
                    });
                } else {
                    this.$store.dispatch("purchase_order/fetchPO", {
                        perPage: this.perPage,
                        currentPage: 1,
                        start_date: this.start_date,
                        end_date: this.end_date,
                        search_term: this.filter,
                        status: this.status,
                        vendor: this.vendor,
                        project: this.project,
                        employee: this.selectedEmployee
                    }).then(() => {
                        this.totalRows = this.count;
                        this.initialLoad = false;
                        this.isModifyingDate = false;
                    });
                }

                }   

               
            }

        },

        end_date(newVal, oldVal) {
            if (!this.initialLoad) {
                if (!this.isModifyingDate) {
                    this.isModifyingDate = true;
                    if (this.end_date !== null) {
                    this.end_date = moment(String(this.end_date)).format("YYYY-MM-DD");

                    this.$store.dispatch("purchase_order/fetchPO", {
                        perPage: this.perPage,
                        currentPage: 1,
                        start_date: this.start_date,
                        end_date: this.end_date,
                        search_term: this.filter,
                        status: this.status,
                        vendor: this.vendor,
                        project: this.project,
                        employee: this.selectedEmployee
                    }).then(() => {
                        this.totalRows = this.count;
                        this.initialLoad = false;
                        this.isModifyingDate = false;
                    });
                } else {
                    this.$store.dispatch("purchase_order/fetchPO", {
                        perPage: this.perPage,
                        currentPage: 1,
                        start_date: this.start_date,
                        end_date: this.end_date,
                        search_term: this.filter,
                        status: this.status,
                        vendor: this.vendor,
                        project: this.project,
                        employee: this.selectedEmployee
                    }).then(() => {
                        this.totalRows = this.count;
                        this.initialLoad = false;
                        this.isModifyingDate = false;
                    });
                }
                }
              
            }

        },

        filter(newVal, oldVal) {
            if (!this.initialLoad) {

                this.$store.dispatch("purchase_order/fetchPO", {
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.status,
                    vendor: this.vendor,
                    project: this.project,
                    employee: this.selectedEmployee
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }

        },

        status(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("purchase_order/fetchPO", {
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.status,
                    vendor: this.vendor,
                    project: this.project,
                    employee: this.selectedEmployee
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }

        },

        vendor(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("purchase_order/fetchPO", {
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.status,
                    vendor: this.vendor,
                    project: this.project,
                    employee: this.selectedEmployee
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }

        },

        project(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("purchase_order/fetchPO", {
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.status,
                    vendor: this.vendor,
                    project: this.project,
                    employee: this.selectedEmployee
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }

        },

        selectedEmployee(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("purchase_order/fetchPO", {
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.status,
                    vendor: this.vendor,
                    project: this.project,
                    employee: this.selectedEmployee
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }

        }
    },

    mounted() {
        this.$store.dispatch("vendor/fetchVendor_without_pg")
        this.$store.dispatch("employee/fetchEmployeeList");
        this.$store.dispatch("department/fetchDepartments")
        this.$store.dispatch("project/fetchProject");
        if (this.initialLoad) {
            if (!this.$route.query.page || !this.$route.query.perPage) {

                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage
                    }
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });

                this.fetchInitialEOD();
            } else {

                this.currentPage = parseInt(this.$route.query.page);
                this.perPage = parseInt(this.$route.query.perPage);

                this.fetchInitialEOD();
            }
        }
    },

    methods: {
        fetchInitialEOD() {
            this.$store.dispatch("purchase_order/fetchPO", {
                    perPage: this.perPage,
                    currentPage: this.currentPage,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.status,
                    vendor: this.vendor,
                    project: this.project,
                    employee: this.selectedEmployee
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },
        toggleFilterShow() {
            this.filterShow = !this.filterShow
        },

        clearFilter() {
            this.filterShow = false,
                this.filter = null,
                this.start_date = null,
                this.end_date = null,
                this.status = '',
                this.vendor = '',
                this.project = '',
                this.selectedDepartment = '',
                this.selectedDesignation = '',
                this.selectedEmployee = ''
        },

        deletePO(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("purchase_order/deletePO", {
                id: this.delete_value,
                currentPage: this.$route.query.page,
                perPage: this.$route.query.perPage,
                start_date: this.start_date,
                end_date: this.end_date,
                search_term: this.filter,
                status: this.status,
                vendor: this.vendor,
                project: this.project,
                employee: this.selectedEmployee
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
